module.exports = __webpack_public_path__ + "static/media/Layer2.33749334.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Layer2.png
// module id = 54
// module chunks = 0